// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .container {
  width: 340px;
}
:host .block-input {
  display: block;
  width: 100%;
}
:host .block-input input {
  width: calc(100% - 5px);
}
:host .block-zones {
  display: block;
  max-height: 220px;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/editor/chart-config/chart-line-property/chart-line-property.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/editor/chart-config/chart-line-property/chart-line-property.component.scss"],"names":[],"mappings":"AACI;EACI,YAAA;ACAR;ADGI;EACI,cAAA;EACA,WAAA;ACDR;ADGQ;EACI,uBAAA;ACDZ;ADKI;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;ACHR","sourcesContent":[":host {\n    .container {\n        width: 340px;\n    }\n\n    .block-input {\n        display: block;\n        width: 100%;\n\n        input {\n            width: calc(100% - 5px);\n        }\n    }\n\n    .block-zones {\n        display: block;\n        max-height: 220px;\n        overflow-y: auto;\n    }\n}",":host .container {\n  width: 340px;\n}\n:host .block-input {\n  display: block;\n  width: 100%;\n}\n:host .block-input input {\n  width: calc(100% - 5px);\n}\n:host .block-zones {\n  display: block;\n  max-height: 220px;\n  overflow-y: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
